import React from "react";
import Calendar from "../../../assets/img/icons/assetCalendar.svg";
import styled from "styled-components";
function AssetCalendar({ data }) {
  const myArr = data.split(" ");
  const date = parseInt(myArr[0]);
  const month = myArr[1];
  const getDate = () => {
    // console.log("let's see the length of the array element one");
    // console.log(myArr[0].length);
    // console.log(myArr[0]);

    if (myArr[0].length === 1) {
      let finalDate = "0" + myArr[0];
      // console.log("we in the length of Asset Calendar");
      return finalDate;
    } else {
      // console.log("we're not in the length of Asset Calendar");
      return date;
    }
  };

  return (
    <Wrapper>
      <img src={Calendar} className="icon" />
      <span className="date">{myArr[0]}</span>
      <span className="month">{month}</span>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  .date {
    position: absolute;
    top: 4px;
    left: 0px;
    color: #c21e1e;
    font-family: roboto_slabregular, serif;
    font-size: 11px;
    font-weight: bold;
    text-align: center;
    width: 100%;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 8px;
      top: 7px;
    }
  }
  .month {
    font-size: 11px;
    font-family: robotomedium, sans-serif;
    font-weight: 500;
    color: #c21e1e;
    text-align: center;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 8px;
    }
  }
`;

export default AssetCalendar;
